export default {
  PhotoReview: {
    queued: { Text: 'En cola' },
    reviewed: { Text: 'Revisado' },
  },
  PhotoRating: {
    pending: {
      Text: 'Pendiente de revisión',
      Description:
        'Disponible para la mayoría de los usuarios (quienes desactivaron la Navegación Segura)',
    },
    public: {
      Text: 'Público',
      Description: 'Disponible para todos',
    },
    'public-sensitive': {
      Text: 'Público',
      Description:
        'Disponible para la mayoría de los usuarios (quienes desactivaron la Navegación Segura)',
    },
    banned: {
      Text: 'Contenido prohibido',
      Description: 'Marcado para eliminación',
    },
    private: {
      Text: 'Privado',
      Description: 'Disponible solo para usuarios autorizados por ti',
    },
    message: {
      Text: 'Elemento de mensaje',
      Description: 'Solo para el destinatario',
    },
    other: {
      Text: 'Desconocido',
      Description: '',
    },
  },
  Community: {
    default: {
      TextField1: 'Ocupación',
      TextField2: 'Educación',
      TextField3: 'Intereses',
    },
    ferzu: {
      TextField1: 'Mi Fursona',
      TextField2: 'Ocupación / Educación',
      TextField3: 'Intereses',
    },
    pupspace: {
      TextField1: 'Mis pasatiempos',
      TextField2: 'Mis kinks y equipo',
      TextField3: 'Mis límites y mi salud',
    },
  },
  CommunityCategories: {
    fandomsRoleplay: { Name: 'Fandoms y rol' },
    plusSize: { Name: 'Tallas grandes' },
    menInterestedInMen: { Name: 'Hombres interesados en hombres' },
  },
  CommunityInfo: {
    headings: {
      about: 'Acerca de {{communityName}}',
      whatYouCanDo: 'Qué puedes hacer en {{communityName}}',
      rules: 'Nuestras reglas de la comunidad',
      welcome: 'Bienvenido a {{communityName}}',
    },
    communities: {
      grommr: {
        caption: 'Gainers y Encouragers (gay)',
        description:
          'Una comunidad de gainers y encouragers para hombres gays y bisexuales que celebra la positividad corporal, el crecimiento, la inclusión y la aceptación.',
        sections: {
          about:
            'Grommr se enorgullece de haber servido a la comunidad de gainers y encouragers gays y bisexuales desde 2011. La comunidad de Grommr reúne a una diversa gama de hombres de todo el mundo que comparten una cosa en común: la mentalidad de que más grande es mejor.\n\nGrommr ofrece un foro inclusivo para que nuestra comunidad se conecte, estreche lazos y prospere. También coordinamos reuniones locales periódicas (llamadas GrommOffs) y organizamos conferencias semestrales más grandes, como The Grom y EuroGrom.\n\nNo somos la primera red en servir a la comunidad gainer-encourager, que se conecta desde sus inicios en la década de 1980. Para conocer más sobre la historia de esta increíble comunidad positiva con el cuerpo, visita <a href="https://www.grommr.com/Home/Community">The Gainer History Project</a>.',
          whatYouCanDo:
            ' • Navega el feed, haz publicaciones, comenta y únete a discusiones.\n • Explora perfiles cercanos o busca miembros con intereses similares.\n • Inicia chats con nuevos contactos o con amigos de siempre.\n • Comparte tus fotos o mira las fotos recientes de otros miembros.\n • Entérate de eventos de la comunidad gainer que ocurren cerca de ti.',
          rules:
            'Nos esforzamos por mantener Grommr como un hogar acogedor para todos nuestros miembros. Cualquier actividad ilegal, troleo, acoso, racismo, misoginia, homofobia, transfobia, capacitismo, gordofobia y exhibiciones públicas de desnudez o actos sexuales están estrictamente prohibidos en Grommr.',
          welcome:
            'Si hay algo en lo que nuestro equipo de administración pueda ayudarte, no dudes en abrir un ticket de soporte o enviarnos un correo electrónico.\n\n¡Bienvenido!\n\nEl equipo de Grommr',
        },
      },
      feabie: {
        caption: 'Feedismo y BBW',
        description:
          'Una comunidad de feedismo para todos que celebra la positividad corporal, el crecimiento, la inclusión y la aceptación.',
        sections: {
          about:
            'Feabie ofrece un entorno inclusivo donde los miembros de la comunidad del feedismo —de todas las orientaciones— pueden conectarse, ya sea para charlar, tener una cita o asistir a un evento comunitario. Damos la bienvenida a feedists, admiradores de gordos, BBW/BHM y a cualquiera que se sienta como en casa en Feabie.\n\nAdemás de nuestra comunidad en línea, Feabie también coordina FeabieMeets, una serie de encuentros locales que reúnen a una amplia variedad de miembros de Feabie para conectar fuera de línea.\n\nFeabie es la red social más grande que sirve a la comunidad del feedismo y una de las redes sociales positivas con el cuerpo más grandes del mundo.',
          whatYouCanDo:
            ' • Navega el feed, haz publicaciones, comenta y únete a discusiones.\n • Explora perfiles cercanos o busca miembros con intereses similares.\n • Inicia un chat y organiza una cita, o simplemente ponte al día con amigos.\n • Comparte tus fotos o mira las fotos recientes de otros miembros.\n • Entérate de eventos de feedismo que suceden cerca de ti.',
          rules:
            'Nuestros administradores trabajan arduamente para mantener Feabie lo más inclusivo y acogedor posible. La actividad ilegal, el troleo, el acoso, el racismo, la misoginia, la homofobia, la transfobia, el capacitismo, la gordofobia y las exhibiciones públicas de desnudez o actos sexuales están estrictamente prohibidos en Feabie.',
          welcome:
            '¡Nuestros administradores están aquí para ayudarte! Si tienes una pregunta o inquietud, no dudes en abrir un ticket de soporte o enviarnos un correo electrónico.\n\n¡Bienvenido!\n\nEl equipo de Feabie',
        },
      },
      chasabl: {
        caption: 'Osos, chubs y chasers (gay)',
        description:
          'Una comunidad chub-bear para hombres gays y bisexuales que celebra la positividad corporal, la inclusión y la aceptación.',
        sections: {
          about:
            'Chasable se enorgullece de haber sido la red social más grande para la comunidad chub-bear desde 2013. Desde entonces, Chasable se ha ganado la reputación de ser un entorno acogedor para hombres gays y bisexuales de todos los tamaños, formas y colores. Damos la bienvenida a chubs, bears, chasers y a cualquiera en medio.\n\nAunque la comunidad chub-bear está atendida por varias apps de citas, ninguna otra app ofrece las funciones sociales que ofrece Chasable. El feed de Chasable es un centro vital de debate, intercambio de fotos y apoyo para la comunidad.\n\nChasable apoya regularmente grandes eventos de la comunidad chub-bear, como Tidal Wave en Orlando y las noches de bar de BGMO en Nueva York, y ayuda a promover eventos chub-bear en todo el mundo.',
          whatYouCanDo:
            ' • Explora chicos cercanos o busca chubs, bears y chasers con intereses similares.\n • Comparte tus fotos o mira las fotos recientes de otros miembros.\n • Navega el feed, haz publicaciones, comenta y únete a discusiones.\n • Envía un coqueteo, inicia un chat con un chico nuevo o ponte al día con amigos.\n • Entérate de eventos chub-bear que suceden cerca de ti.',
          rules:
            'Los administradores de Chasable ayudan a mantener nuestra comunidad como un espacio seguro para todos. La actividad ilegal, el troleo, el acoso, el racismo, la misoginia, la homofobia, la transfobia, el capacitismo, la gordofobia y las exhibiciones públicas de desnudez o actos sexuales están estrictamente prohibidos en Chasable.',
          welcome:
            '¿Tienes preguntas? ¿Ves algo que no debería estar en Chasable? ¡Nuestro equipo de administración está aquí para ayudar! Abre un ticket de soporte en cualquier momento o envíanos un correo electrónico.\n\n¡Bienvenido!\n\nEl equipo de Chasable',
        },
      },
      ferzu: {
        caption: 'Furries y anthros',
        description:
          'Una comunidad furry para todos que celebra el fandom furry, el arte furry y la inclusión.',
        sections: {
          about:
            'Ferzu es la red social más grande dedicada a servir al fandom furry. Ya sea que tu fursona camine, vuele o nade, seas heterosexual o LGBTQ, rellenito o delgado, a rayas o con manchas, encontrarás un hogar inclusivo en Ferzu.\n\nNos enorgullece brindar un espacio seguro para que todos los furries se conecten y florezcan. A menudo, en Ferzu suceden conversaciones que nunca ocurrirían en las redes sociales convencionales más permisivas con los trolls.',
          whatYouCanDo:
            ' • Navega el feed, haz publicaciones, comenta y únete a discusiones.\n • Mira las últimas obras de arte furry y comparte las tuyas.\n • Explora perfiles cercanos o busca furries con intereses similares.\n • Inicia chats con nuevos contactos o con amigos de siempre.\n • Entérate de convenciones furry, mira quién irá y únete a la diversión.',
          rules:
            'Ferzu es un espacio seguro para todos los furries. Por ello, el troleo, el acoso, el racismo, la misoginia, la homofobia, la transfobia, el capacitismo y las exhibiciones públicas de desnudez o actos sexuales están estrictamente prohibidos.\n\nTambién nos importan profundamente los artistas que forman la columna vertebral de nuestra comunidad. Por eso, nuestros administradores aplican políticas estrictas para proteger el arte furry.',
          welcome:
            'Nuestro equipo de administración siempre está disponible para responder tus preguntas o ayudarte con cualquier problema en Ferzu. Si necesitas algo, no dudes en abrir un ticket de soporte o enviarnos un correo electrónico.\n\n¡Un gran saludo furry!\n\nEl equipo de Ferzu',
        },
      },
      pupspace: {
        caption: 'Cachorros humanos y handlers',
        description:
          'Una nueva comunidad de pup play para cachorros humanos, handlers y cualquiera que ame entrar en la mentalidad de cachorro.',
        sections: {
          about:
            'Pupspace es la primera red social y app dedicada a servir a la comunidad del puppy play y a nuestros amigos. Se da la bienvenida a miembros de todos los géneros, identidades y orígenes.\n\nNos esforzamos por construir una comunidad inclusiva y enriquecedora para todos nuestros miembros, sin importar cómo te identifiques, dónde vivas o si tienes pareja o no. Pupspace es un lugar seguro donde los miembros pueden explorar, ser ellos mismos, entrar en la mentalidad de cachorro y liberar a su cachorro interior.',
          whatYouCanDo:
            '• Navega el feed, haz publicaciones, comenta y únete a discusiones con otros cachorros y handlers.\n• Explora perfiles cercanos o busca cachorros con intereses similares.\n• Inicia un chat, organiza una cita de juego o simplemente ponte al día con amigos.\n• Comparte tus fotos o mira fotos recientes de otros cachorros.\n• Entérate de eventos y moshes de cachorros que suceden cerca de ti.',
          rules:
            'Los administradores de Pupspace trabajan arduamente para mantener nuestra comunidad lo más inclusiva y acogedora posible. La actividad ilegal, el troleo, el acoso, el racismo, la misoginia, la homofobia, la transfobia, el capacitismo y las exhibiciones públicas de desnudez o actos sexuales están estrictamente prohibidos en Pupspace.',
          welcome:
            '¡Nuestros administradores están aquí para ayudar! Si tienes una pregunta o inquietud, no dudes en abrir un ticket de soporte o enviarnos un correo electrónico.\n\n¡Bienvenido a tu nuevo hogar! *wags*\n\nEl equipo de Pupspace',
        },
      },
    },
  },
  communities: {
    myCommunities: 'Mis comunidades',
  },
  PostType: {
    ChangedLocation: 'Cambió su ubicación a: {{text}}',
    ChangedNickname: 'Cambió su nombre de usuario: {{text}}',
    ChangedRelStatus: 'Cambió su estado de relación',
    ChangedWeight: 'Cambió su peso a {{newWeight}}, una ganancia de {{newWeightDiff}}',
    NewMember: 'Se unió a {{communityName}}',
    NewPhoto: 'Publicó una nueva foto',
    NewEvent: 'Publicó un nuevo evento: ',
    NotifyNewComment: {
      post: 'comentó en una publicación',
      photo: 'comentó en una foto',
    },
    NotifyNewFollow: 'comenzó a seguirte',
    NotifyNewWallToWall: 'publicó en tu muro',
    NotifyPhotoLike: 'le gustó tu foto',
    NotifyUnlocked: 'te concedió acceso a sus fotos privadas',
    NotifyUnlockRequest: 'está solicitando acceso a tus fotos privadas',
  },
  TransactionType: {
    Admin: 'Pase {{premium}} de administrador',
    Adjustment: 'Ajuste',
    BOGO: 'Promoción {{premium}} (compra uno, llévate uno gratis)',
    Courtesy: 'Pase {{premium}} de cortesía',
    DonationWithPaypal: '¡Donación, gracias! (pagado con PayPal)',
    FoundingMember: 'Pase {{premium}} de miembro fundador',
    GiftCertificatePaidFor: 'Compra de certificado de regalo {{premium}}',
    GiftCertificateRedeemed: 'Certificado de regalo {{premium}} canjeado',
    PaidByMail: 'Compra de pase {{premium}} (pagado con efectivo/cheque/giro postal)',
    PaidWithApple: 'Suscripción {{premium}} (pagado con Apple App Store)',
    PaidWithCCBill: 'Suscripción {{premium}} (pagado con CCBill)',
    PaidWithGoogle: 'Suscripción {{premium}} (pagado con Google Play)',
    PaidWithPaypal: 'Compra de pase {{premium}} (pagado con PayPal)',
    PaidWithStripe: 'Suscripción {{premium}} (pagado con Stripe)',
    Referrals: 'Tiempo {{premium}} ganado por referencias',
    Refund: 'Crédito/Reembolso',
    Trial: 'Prueba gratuita {{premium}}',
  },

  ProfileTags: {
    BodyFeatures: {
      Armpits: 'Axilas',
      ArmsLegs: 'Brazos/piernas',
      Asses: 'Traseros',
      Athletic: 'Atlético',
      Average: 'Promedio',
      Balbo: 'Balbo',
      BallBelly: 'Barriga de pelota',
      Beard: 'Barba',
      Beards: 'Barbas',
      Bellies: 'Barrigas',
      BellyButtons: 'Ombligos',
      BodyMods: 'Modificación corporal',
      Breasts: 'Senos (femeninos)',
      BreastsFemale: 'Senos (femeninos)',
      BreastsMale: 'Senos (masculinos)',
      ChestPecs: 'Pecho/pectorales',
      ChinStrap: 'Barbilla recortada',
      Chubby: 'Regordete en todo',
      Chubby2: 'Regordete',
      ChubbyBelly: 'Regordete con barriga',
      ChunkyMuscle: 'Músculo corpulento',
      Curvy: 'Curvilíneo',
      Feet: 'Pies',
      First30: 'Primeras 30 libras',
      FullBeard: 'Barba completa',
      Goatee: 'Perilla',
      Hairy: 'Velludo',
      Hands: 'Manos',
      Husky: 'Robusto',
      LightBeard: 'Barba ligera',
      LoveHandles: 'Michelines',
      ManTits: 'Tetas masculinas',
      Moustache: 'Bigote',
      MuscleGut: 'Músculo y barriga',
      Muscular: 'Muscular',
      MuttonChops: 'Patillas',
      Nipples: 'Pezones',
      None: 'Ninguna',
      PearChubby: 'Regordete en forma de pera',
      PencilThin: 'Línea fina de lápiz',
      Piercings: 'Perforaciones',
      SlightlyChubby: 'Ligeramente regordete',
      Slim: 'Delgado',
      Smooth: 'Suave',
      SomeHair: 'Algo de vello',
      SuperChub: 'Súper regordete',
      SuperChubby: 'Súper regordete',
      Tattoos2: 'Tatuajes',
      ThickCurvy: 'Grueso/curvilíneo',
      Thin: 'Delgado',
      Toned: 'Músculo tonificado',
      Trimmed: 'Recortado',
      VanDyke: 'Van Dyke',
      VeryChubby: 'Muy regordete',
      VeryHairy: 'Muy velludo',
    },
    Other: {
      AfterCare: 'Cuidados posteriores',
      Agender: 'Agénero',
      AgePlay: 'Juego de edad',
      AnalPlayBottom: 'Anal (pasivo)',
      AnalPlayTop: 'Anal (activo)',
      Androgynous: 'Andrógino',
      Asexuality: 'Asexualidad',
      Babyfur: 'DiaperFur',
      BalloonPlay: 'Juego con globos',
      Bathing: 'Bañarse/Ducharse',
      BDSM: 'BDSM',
      Belching: 'Eructos',
      BellyPlay: 'Juego de barriga',
      BellyRubs: 'Frotar barriga',
      Biting: 'Morder',
      BitsGags: 'Mordazas',
      Bloating: 'Hinchazón',
      Blueberry: 'Arándano',
      BodyOdors: 'Aroma/Olor corporal',
      Bodypaint: 'Pintura corporal',
      BodyWorship: 'Adoración corporal',
      Bondage: 'Bondage/dominación',
      Bondage2: 'Bondage',
      Boots: 'Botas',
      BootsHeels: 'Botas y tacones',
      BootsWorship: 'Adoración de botas',
      BowlEating: 'Comer de un tazón',
      Brats: 'Malcriados',
      BreastGrowth: 'Crecimiento de senos',
      BreathPlay: 'Juego de respiración',
      Burping: 'Eructos',
      Businessmen: 'Hombres de negocios',
      ButtplugsDildos: 'Plugs anales/Consoladores',
      CageSleep: 'Dormir en jaula',
      CBT: 'CBT',
      Chastity: 'Castidad',
      Cigars: 'Puros/pipas/tabaco',
      CollaredOwned: 'Con collar/Poseído',
      Complicated: 'Es complicado',
      Control: 'Control',
      CrossDress: 'Travestismo',
      Cuckolding: 'Cuckolding',
      Cuddling: 'Acurrucarse/frotage',
      CunnGiver: 'Cunnilingus (dar)',
      CunnReceiver: 'Cunnilingus (recibir)',
      DaddySon: 'Juego de roles papi-hijo',
      Dating: 'Citas',
      DatingBreak: 'Tomando un descanso de las citas',
      Diapers: 'AB/DL',
      DirtyFur: 'Dirtyfur',
      DirtyTalking: 'Hablar sucio',
      Discipline: 'Disciplina/Castigos',
      DoctorPatient: 'Juego de roles doctor-paciente',
      Dogshow: 'Exposición canina',
      Domination: 'Dominación',
      DomSub: 'Dominación/sumisión',
      EdgePlay: 'Edgeplay',
      EdgingOrgasm: 'Control de orgasmo/edging',
      Engaged: 'Comprometido',
      EStim: 'Electroestimulación',
      Exhibitionism: 'Exhibicionismo/Sexo público',
      ExplodBellies: 'Barrigas explotando',
      FaceSitting: 'Sentarse en la cara',
      Farting: 'Pedos',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FeedingFeedee: 'Feeding (recibir)',
      FeedingFeeder: 'Feeding (dar)',
      Female: 'Mujer',
      Feminine: 'Femenino',
      Fighting: 'Lucha/Pelea',
      Fingering: 'Dedeo',
      Fisting: 'Fisting',
      FistingBottom: 'Fisting (pasivo)',
      FistingTop: 'Fisting (activo)',
      Flogging: 'Azotes/Látigos',
      FootWorship: 'Adoración de pies',
      ForceFeeding: 'Feeding forzada',
      Furries: 'Furries',
      Fursuit: 'Fursuit',
      Gaining: 'Ganar peso/alentar',
      GainingInstant: 'Ganancia instantánea',
      GainingLT: 'Ganancia a largo plazo',
      Gassy: 'Gaseoso',
      Genderfluid: 'Género fluido',
      GenderNonconforming: 'No conforme al género',
      GenderShifting: 'Cambio de género',
      GroupSex: 'Sexo grupal',
      GrowUnhealthy: 'Crecimiento no saludable',
      Gunge: 'Lodo',
      GutPunch: 'Golpes en el estómago',
      HandJob: 'Masturbación manual',
      HandlerTrainer: 'Entrenador/Manejador',
      HandsfreeOrgasm: 'Orgasmo sin manos',
      HeatEstrus: 'Celo/Estro',
      Heels: 'Tacones',
      Humiliation: 'Humillación',
      Hypnosis: 'Hipnosis',
      Hypnotization: 'Hipnosis',
      Immobility: 'Ganar hasta la inmovilidad',
      Inflation: 'Inflación',
      Intersex: 'Intersexual',
      InTraining: 'En entrenamiento',
      KennelSleep: 'Dormir en perrera/canasta',
      Kissing: 'Besar',
      KnotPlay: 'Juego de nudos/atar',
      Latex: 'Látex',
      LeashWalk: 'Caminar con correa',
      Leather: 'Cuero',
      Licking: 'Lamer',
      Lipstick: 'Uñas y lápiz labial',
      Lycantropy: 'Licantropía',
      Lycra: 'Lycra',
      MacroMicro: 'Fantasías macro/micro',
      Male: 'Hombre',
      MalePreg: 'Mpreg (embarazo masculino)',
      ManScent: 'Olor masculino/corporal',
      Married: 'Casado',
      Masculine: 'Masculino',
      Masochism: 'Masoquismo',
      Mature: 'Parejas maduras/mayores',
      Measuring: 'Medir/pesar',
      Men: 'Hombres',
      MessyEat: 'Comer desordenadamente',
      MessyEating: 'Comer desordenado/juego de cerdo',
      MicroPenis: 'Micropene',
      Military: 'Militar',
      Monogamous: 'Monógamo',
      MpregBirthing: 'Mpreg/parto',
      Murrsuit: 'Murrsuit',
      MuscleGrow: 'Crecimiento muscular',
      MuscleWorship: 'Adoración muscular',
      Musk: 'Almizcle',
      MutualMasturb: 'Masturbación mutua',
      Muzzles: 'Bozales',
      Neoprene: 'Neopreno',
      NipplePlay: 'Juego de pezones',
      NonBinary: 'No binario',
      NonSexPupPlay: 'Juego de Pup no sexual',
      Obedience: 'Entrenamiento de obediencia/comandos',
      OlderMen: 'Hombres maduros/mayores',
      OpenPolyRelation: 'En una relación poli abierta',
      OpenRelationship: 'En una relación abierta',
      OralBottom: 'Oral (pasivo)',
      OralPlayBottom: 'Oral (dar)',
      OralPlayTop: 'Oral (recibir)',
      OralTop: 'Oral (activo)',
      Other: 'Otro',
      Oviposition: 'Oviposición',
      Owner: 'Dueño',
      Pack: 'En una manada',
      Padding: 'Relleno',
      Pegging: 'Pegging',
      Petting: 'Rascar/acariciar',
      PigPlay: 'Juego de cerdo',
      PissPlay: 'Juegos de orina/deportes acuáticos',
      Plugtail: 'Cola con plug',
      Plush: 'Peluche',
      Polyamorous: 'Poliamoroso',
      PolyRelation: 'En una relación poli',
      Pregnancy: 'Embarazo',
      Primal: 'Primitivo',
      PublicSex: 'Sexo público/voyeurismo',
      Punks: 'Punks',
      PupGear: 'Equipo de Pup',
      PupPlay: 'Juego de Pup',
      PuppyGames: 'Juegos de Pup (buscar, fosa de pelotas)',
      PuppyToys: 'Juguetes de Pup',
      Queer: 'Queer',
      Relationship: 'En una relación',
      Rimming: 'Rimming',
      RimmingGiver: 'Rimming (dar)',
      RimmingReceiver: 'Rimming (recibir)',
      RolePlay: 'Juego de roles',
      Rubber: 'Goma',
      RubberLatexLeather: 'Goma/látex/cuero',
      Sadism: 'Sadismo',
      SadoMaso: 'Sadomasoquismo',
      Saline: 'Salino',
      Scat: 'Scat',
      SciFiGain: 'Ganancia de ciencia ficción',
      Scratching: 'Rascar',
      SensoryDep: 'Privación sensorial',
      SexualCanineRole: 'Rol canino sexual',
      SheathPlay: 'Juego de prepucio',
      Single: 'Soltero',
      Skinheads: 'Cabezas rapadas',
      Smashing: 'Aplastar/machacar',
      SmashingSitting: 'Aplastar/sentarse sobre alguien',
      Sniffing: 'Olfatear',
      Sounding: 'Sounding/catéteres',
      Spanking: 'Spanking',
      SpeciesSpecific: 'Específico de especie',
      Speedos: 'Speedos/lycra',
      Sportswear: 'Ropa deportiva',
      Squashing: 'Aplastar',
      StraightMen: 'Hombres heterosexuales/casados',
      Stray: 'Callejero',
      StretchMarks: 'Estrías',
      Stuffing: 'Rellenar',
      Submission: 'Sumisión',
      Suits: 'Trajes',
      Swinging: 'Swinging y sexo grupal',
      TailPulling: 'Tirar de la cola',
      Tattoos: 'Tatuajes/perforaciones',
      Teasing: 'Provocar',
      TeasingPublic: 'Provocar/humillación pública',
      Technophilia: 'Tecnofilia',
      Tentacles: 'Tentáculos',
      Tickling: 'Cosquillas',
      TightClothes: 'Ropa ajustada/botones saltando',
      Toons: 'Toons',
      Toys: 'Juguetes/consoladores',
      Trans: 'Transexuales/intersexuales',
      Transformation: 'Transformación',
      Transgender: 'Transgénero',
      TransMan: 'Hombre trans',
      TransMen: 'Hombres trans',
      TransWoman: 'Mujer trans',
      TransWomen: 'Mujeres trans',
      Treats: 'Premios/golosinas',
      TwoSpirit: 'Dos espíritus',
      Uncle: 'Fantasías de tío/padre/primo',
      UncollaredUnowned: 'Sin collar/sin dueño',
      UnderConsideration: 'Bajo consideración',
      Underwear: 'Ropa interior',
      Uniforms: 'Uniformes',
      VacantKennel: 'Perrera vacante',
      VacBed: 'Cama de vacío/sacos de dormir',
      Vanilla: 'Vainilla/abrazos',
      VetRoleplay: 'Juego de roles veterinario-mascota',
      Vore: 'Vore',
      VoyeurExhib: 'Voyeurismo y exhibicionismo',
      Voyeurism: 'Voyeurismo',
      WaterSports: 'Deportes acuáticos',
      WaxPlay: 'Juego con cera',
      WeightGain: 'Ganancia de peso',
      Wet: 'Look mojado/jeans mojados',
      Widowed: 'Viudo',
      Women: 'Mujeres',
      Wrestling: 'Lucha/singlets',
    },
    SocialTags: {
      Admirer: 'Admirer',
      Alpha: 'Alfa',
      Amphibian: 'Anfibio',
      Aquatic: 'Acuático',
      Avian: 'Ave',
      BBW: 'Mujer hermosa y grande',
      Bear: 'Oso',
      BearSpecie: 'Oso',
      Beta: 'Beta',
      BHM: 'Hombre hermoso y grande',
      Bloater: 'Bloater',
      Bovid: 'Bóvido',
      Boy: 'Chico',
      Bull: 'Toro',
      Canid: 'Cánido',
      Cervid: 'Cérvido',
      CatKitten: 'Gato/Gatito',
      Chaser: 'Perseguidor',
      Chub: 'Regordete',
      Chub4Chub: 'Regordete4Regordete',
      ChubbyBear: 'Oso Regordete',
      Cub: 'Cachorro',
      Daddy: 'Papi',
      Dog: 'Perro',
      Dominant: 'Dom',
      Dragon: 'Dragón',
      Encourager: 'Encourager',
      Exotic: 'Exótico',
      FA: 'Fat Admirer',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FelineLarge: 'Felino (grande)',
      FelineSmall: 'Felino (pequeño)',
      Fox: 'Zorro',
      FriendOfPups: 'Amigo de Pups',
      Gainer: 'Gainer',
      HandlerTrainer: 'Entrenador/Manejador',
      Horse: 'Caballo',
      HorsePony: 'Caballo/Poni',
      Hybrid: 'Híbrido',
      Maintainer: 'Maintainer',
      Marsupial: 'Marsupial',
      Master: 'Amo',
      Mistress: 'Ama',
      Mommy: 'Mami',
      MuscleGainer: 'Gainer Muscular',
      Omega: 'Omega',
      Otter: 'Nutria',
      OtherMammal: 'Otro (mamífero)',
      OtherSpecie: 'Otra',
      Panda: 'Panda',
      PetOther: 'Mascota (otra)',
      Primate: 'Primate',
      Pup: 'Pup',
      Rabbit: 'Conejo',
      Raccoon: 'Mapache',
      Reptilian: 'Reptil',
      Rodent: 'Roedor',
      Sir: 'Señor',
      Skunk: 'Mofeta',
      Slave: 'Esclavo',
      Submissive: 'Sub',
      Switch: 'Switch',
      Wolf: 'Lobo',
    },
    Languages: {
      Arabic: 'Árabe',
      Bulgarian: 'Búlgaro',
      Chinese: 'Chino',
      Czech: 'Checo',
      Danish: 'Danés',
      Dutch: 'Holandés',
      English: 'Inglés',
      Filipino: 'Filipino',
      Finnish: 'Finlandés',
      French: 'Francés',
      German: 'Alemán',
      Greek: 'Griego',
      Hebrew: 'Hebreo',
      Hindi: 'Hindi',
      Hungarian: 'Húngaro',
      Indonesian: 'Indonesio',
      Italian: 'Italiano',
      Japanese: 'Japonés',
      Korean: 'Coreano',
      Norwegian: 'Noruego',
      Others: 'Otro(s)',
      Persian: 'Persa',
      Polish: 'Polaco',
      Portuguese: 'Portugués',
      Romanian: 'Rumano',
      Russian: 'Ruso',
      SerboCroatian: 'Serbocroata',
      Sign: 'Lenguaje de señas',
      Slovak: 'Eslovaco',
      Spanish: 'Español',
      Swedish: 'Sueco',
      Thai: 'Tailandés',
      Turkish: 'Turco',
      Ukranian: 'Ucraniano',
      Urdu: 'Urdu',
      Vietnamese: 'Vietnamita',
    },
    Interests: {
      AddPackMembers: 'Expandir mi manada',
      Alpha: 'Alfa',
      AsexualRelationship: 'Relación asexual',
      BdsmDynamic: 'Dinámica BDSM',
      Beta: 'Beta',
      Boy: 'Chico',
      Collaring: 'Collar',
      Daddy: 'Papi',
      Date: 'Cita',
      Dominant: 'Dom',
      Exploration: 'Iniciación/Exploración',
      FormPack: 'Formar una nueva manada',
      Friends: 'Amigos',
      Gaming: 'Juegos',
      HandlerTrainer: 'Entrenador/Manejador',
      Hookup: 'Encuentro casual',
      JoinPack: 'Unirse a una manada existente',
      Master: 'Amo',
      Mistress: 'Ama',
      Mommy: 'Mami',
      Moshes: 'Moshes/eventos de cachorros',
      NonSexualPlaymates: 'Compañeros de juego no sexuales',
      Omega: 'Omega',
      OnlineChat: 'Chat en línea',
      OnlineVideo: 'Video en línea (cam2cam)',
      PolyRelation: 'Relación poli',
      PolyRelationship: 'Relación poli',
      Relationship: 'Relación',
      RoleplayPartner: 'Compañero de juego de roles',
      RomanticPartner: 'Pareja romántica',
      Sex: 'Encuentro casual',
      SexPartner: 'Pareja íntima regular',
      Sir: 'Señor',
      Slave: 'Esclavo',
      Submissive: 'Sub',
      Switch: 'Switch',
      Training: 'Entrenamiento',
      VideoChat: 'Video chat',
    },
    Ethnicities: {
      Arab: 'Medio Oriente/norte de África',
      Asian: 'Asiático oriental',
      Black: 'Negro/descendencia africana',
      Hispanic: 'Hispano/Latinx',
      Mixed: 'Mixto/multi',
      Native: 'Nativo americano/indígena',
      Pacific: 'Isleño del Pacífico',
      SouthAsian: 'Asiático del sur',
      White: 'Blanco/caucásico',
    },
  },
};
